import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installClientContextCapture } from "./utils/clientContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

// Before anything renders: the errors worth showing the AI Support assistant
// happen long before a therapist thinks to open it. Nothing is transmitted
// until a session is active.
installClientContextCapture();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
